import React from 'react';

const HeroSection = () => {
  return (
    <section>
      <div
        id="intro"
        className="text-center bg-image hero-section"
        style={{
          backgroundImage: "url('/images/Bitejoy/1767899345026.jpg')",
        }}
      >
        <div className="mask">
          <div className="d-flex justify-content-center align-items-center h-100 mt-4">
            <div>
              <h1 className="display-1" style={{ color: '#ffffff' }}>
                BITE JOY
              </h1>
              <hr className="my-2 bg-dark" />
              <h4 className="font-weight-light mb-4" style={{ color: '#fff' }}>
                We are happy to have you here!
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
